module.exports = __webpack_public_path__ + "static/media/s_v10_16.f6478c93.mp3";